<script setup lang="ts">
  import type { TrainingStatus, MemberTrainingStatus } from '@/entities/Training';
  import { MEMBER_TRAINING_STATUS_LABELS } from '@/entities/Training';

  defineProps<{ status: TrainingStatus | MemberTrainingStatus }>();
</script>

<template>
  <span
    class="inline-flex items-center px-3 py-1 rounded-full text-xs/3.5 font-medium"
    :class="{
      'bg-badge-orange-30 text-badge-orange': status === 'PENDING',
      'bg-green-20 text-gray-07': status === 'COMPLETED',
      'bg-gray-02 text-gray-05': status === 'NOT_COMPLETED',
    }"
  >
    {{ MEMBER_TRAINING_STATUS_LABELS[status] }}
  </span>
</template>
